import { __extends } from "tslib";
import { CameraInputsManager } from "./cameraInputsManager.js";
import { FollowCameraKeyboardMoveInput } from "./Inputs/followCameraKeyboardMoveInput.js";
import { FollowCameraMouseWheelInput } from "./Inputs/followCameraMouseWheelInput.js";
import { FollowCameraPointersInput } from "./Inputs/followCameraPointersInput.js";
/**
 * Default Inputs manager for the FollowCamera.
 * It groups all the default supported inputs for ease of use.
 * @see https://doc.babylonjs.com/how_to/customizing_camera_inputs
 */
var FollowCameraInputsManager = /** @class */ (function (_super) {
    __extends(FollowCameraInputsManager, _super);
    /**
     * Instantiates a new FollowCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */
    function FollowCameraInputsManager(camera) {
        return _super.call(this, camera) || this;
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */
    FollowCameraInputsManager.prototype.addKeyboard = function () {
        this.add(new FollowCameraKeyboardMoveInput());
        return this;
    };
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */
    FollowCameraInputsManager.prototype.addMouseWheel = function () {
        this.add(new FollowCameraMouseWheelInput());
        return this;
    };
    /**
     * Add pointers input support to the input manager.
     * @returns the current input manager
     */
    FollowCameraInputsManager.prototype.addPointers = function () {
        this.add(new FollowCameraPointersInput());
        return this;
    };
    /**
     * Add orientation input support to the input manager.
     * @returns the current input manager
     */
    FollowCameraInputsManager.prototype.addVRDeviceOrientation = function () {
        console.warn("DeviceOrientation support not yet implemented for FollowCamera.");
        return this;
    };
    return FollowCameraInputsManager;
}(CameraInputsManager));
export { FollowCameraInputsManager };
//# sourceMappingURL=followCameraInputsManager.js.map